<template>
  <form @submit.prevent="confirmOrder" class="mt-3">
    <div class="form-group">
      <div class="form-check">
        <input
          id="terms"
          type="checkbox"
          class="form-check-input"
          :class="{'is-invalid': $v.terms.$error, 'is-valid': !$v.terms.$error && $v.terms.$dirty}"
          v-model="terms"
          @change="$v.terms.$touch()"
        >
        <label class="form-check-label" for="terms">
          Ik ga akkoord met de <a href="/pdf/algemene_voorwaarden_oldevuuren.pdf" target="_blank" class="link underline">algemene voorwaarden</a>
          van Oldevuuren
        </label>
        <div v-if="$v.terms.$invalid" class="invalid-feedback">
          Je moet akkoord gaan met de voorwaarden!
        </div>
      </div>
    </div>

    <div class="col-md-13 p-0 mt-3">
      <button type="submit" :disabled="$v.$invalid || confirmingOrder" :class="{'disabled cursor-not-allowed': $v.$invalid}" class="btn btn-oldevuuren w-100 btn-round">
        Bestellen
        <font-awesome-icon class="font-awesome-icon" v-if="confirmingOrder" icon="spinner" spin/>
      </button>
    </div>
  </form>
</template>

<script>
  import { sameAs } from 'vuelidate/lib/validators'
  import { CONFIRM_ORDER } from '../../store/types'

  export default {
    data() {
      return {
        terms: false
      }
    },
    validations: {
      terms: {
        sameAs: sameAs(() => true)
      }
    },
    computed: {
      confirmingOrder() {
        return !this.$store.getters.confirmingOrder ? false : this.$store.getters.confirmingOrder
      }
    },
    methods: {
      confirmOrder() {
        this.$store.dispatch(CONFIRM_ORDER)
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
